module.exports = "/_next/static/images/icon_instagram2-094cca2101e15eb656f7bd341bd4bbce.svg";